<mat-card>
  <mat-card-content>
    <button mat-raised-button (click)="openAddUserModal()">Add New User</button>
    <mat-form-field class="full-width" appearance="outline" color="accent">
      <mat-label>Search Users</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Search by email"
      />
    </mat-form-field>
    <div class="user-table-container">
      <table
        mat-table
        [dataSource]="usersDataSource"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="provider">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
          <td mat-cell *matCellDef="let user">{{ user.provider }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let user">{{ user.email }}</td>
        </ng-container>
        <ng-container matColumnDef="isAdmin">
          <th mat-header-cell *matHeaderCellDef>Admin</th>
          <td mat-cell *matCellDef="let user">
            {{ user.isAdmin ? "Yes" : "No" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let user">
            <button
              mat-icon-button
              color="accent"
              (click)="toggleAdminStatus(user)"
            >
              <mat-icon>{{
                user.isAdmin ? "remove_circle" : "add_circle"
              }}</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              (click)="confirmDeleteUser(user.email)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <mat-spinner
      *ngIf="loadingUsers"
      class="user-loading-spinner"
      [diameter]="40"
    ></mat-spinner>
    <mat-card *ngIf="usersErrorMessage" class="user-error-message">
      {{ usersErrorMessage }}
    </mat-card>
  </mat-card-content>
</mat-card>
